import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";
import colors from "vuetify/es5/util/colors";

Vue.use(Vuetify, {
  iconfont: "md",
  theme: {
    primary: "#66BB6A",
    secondary: "#424242",
    accent: "#ffe0b2",
    error: "#FF5252",
    info: "#2196F3",
    warning: "#4CAF50",
    success: colors.green,
    test: "#000000"
  }
});
